import { AVAILABLE_CURRENCIES } from "./globals";

enum TYPE_OF_SUBPARTS {
  "SUBTOTAL" = "SUBTOTAL",
  "URSSAF" = "URSSAF",
  "VOUCHER" = "VOUCHER",
  "BALANCE" = "BALANCE",
  "DISCOUNT" = "DISCOUNT",
}

interface PriceSubpartDTO {
  type: string;
  price: number;
  label: string;
  description: string | null;
  tooltip: string | null;
}

interface PriceSubpart {
  type: TYPE_OF_SUBPARTS;
  price: number;
  currency: AVAILABLE_CURRENCIES;
  label: string;
  description: string | null;
  tooltip: string | null;
}

export { TYPE_OF_SUBPARTS, PriceSubpartDTO, PriceSubpart };
